import { render, staticRenderFns } from "./BubbleNews.vue?vue&type=template&id=488634a0&scoped=true&"
import script from "./BubbleNews.vue?vue&type=script&lang=js&"
export * from "./BubbleNews.vue?vue&type=script&lang=js&"
import style0 from "./BubbleNews.vue?vue&type=style&index=0&id=488634a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488634a0",
  null
  
)

export default component.exports